module.exports = __webpack_public_path__ + "img/ArcGis.f039d8dc.png";